import { useState, useEffect } from 'react'
import { categoriesApi } from '../services/api'

export function useCategories() {
  const [categories, setCategories] = useState([])
  const [loading,    setLoading]    = useState(true)
  const [error,      setError]      = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    categoriesApi.list()
      .then(res => { if (!cancelled) setCategories(res.data ?? []) })
      .catch(err => { if (!cancelled) setError(err.message) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [])

  return { categories, loading, error }
}
